var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "M207 65a7 7 0 1 1 0 14h-40a7 7 0 1 1 0 14h22a7 7 0 1 1 0 14h-10.174c-4.874 0-8.826 3.134-8.826 7q0 3.866 6 7a7 7 0 1 1 0 14H93a7 7 0 1 1 0-14H54a7 7 0 1 1 0-14h40a7 7 0 1 0 0-14H69a7 7 0 1 1 0-14h40a7 7 0 1 1 0-14zm0 28a7 7 0 1 1 0 14 7 7 0 0 1 0-14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  d: "M120.5 133c18.502 0 33.5-14.998 33.5-33.5 0-18.501-14.998-33.5-33.5-33.5S87 80.999 87 99.5c0 18.502 14.998 33.5 33.5 33.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeWidth: 3,
  d: "M120.5 133c18.502 0 33.5-14.998 33.5-33.5 0-18.501-14.998-33.5-33.5-33.5S87 80.999 87 99.5c0 18.502 14.998 33.5 33.5 33.5Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M120.5 133c18.502 0 33.5-14.998 33.5-33.5 0-18.501-14.998-33.5-33.5-33.5S87 80.999 87 99.5c0 18.502 14.998 33.5 33.5 33.5Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M115.132 125.494q2.638.487 5.368.506c14.636 0 26.5-11.864 26.5-26.5S135.136 73 120.5 73c-3.76 0-7.336.783-10.576 2.195a26.6 26.6 0 0 0-13.028 12.247A26.4 26.4 0 0 0 94 99.5a26.4 26.4 0 0 0 6.684 17.596",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M115.132 125.494q2.638.487 5.368.506c14.636 0 26.5-11.864 26.5-26.5S135.136 73 120.5 73c-3.76 0-7.336.783-10.576 2.195a26.6 26.6 0 0 0-13.028 12.247A26.4 26.4 0 0 0 94 99.5a26.4 26.4 0 0 0 6.684 17.596"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M115.132 125.494q2.638.487 5.368.506c14.636 0 26.5-11.864 26.5-26.5S135.136 73 120.5 73c-3.76 0-7.336.783-10.576 2.195a26.6 26.6 0 0 0-13.028 12.247A26.4 26.4 0 0 0 94 99.5a26.4 26.4 0 0 0 6.684 17.596"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M103.797 120.075a26.5 26.5 0 0 0 7.204 4.172"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M103.797 120.075a26.5 26.5 0 0 0 7.204 4.172"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeWidth: 3,
  d: "m148 126 6 6"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "m148 126 6 6"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "M153.03 131.03a4.85 4.85 0 0 0 0 6.854l11.086 11.086a4.848 4.848 0 0 0 6.854-6.854l-11.085-11.086a4.85 4.85 0 0 0-6.855 0",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeWidth: 3,
  d: "M153.03 131.03a4.85 4.85 0 0 0 0 6.854l11.086 11.086a4.848 4.848 0 0 0 6.854-6.854l-11.085-11.086a4.85 4.85 0 0 0-6.855 0Z",
  clipRule: "evenodd"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M153.03 131.03a4.85 4.85 0 0 0 0 6.854l11.086 11.086a4.848 4.848 0 0 0 6.854-6.854l-11.085-11.086a4.85 4.85 0 0 0-6.855 0Z",
  clipRule: "evenodd"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2.5,
  d: "m158 133 11 11"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "M114 88c0 11.598 9.402 21 21 21 2.278 0 4.472-.363 6.526-1.034-3.353 8.321-11.503 14.195-21.026 14.195-12.515 0-22.66-10.146-22.66-22.661 0-11.34 8.33-20.735 19.205-22.399A20.9 20.9 0 0 0 114 88",
  clipRule: "evenodd"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M122 82c-1.273 0-2.518.125-3.721.364m-3.634 1.112C107.804 86.351 103 93.114 103 101"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M174.176 99.777H166M180.5 92h-17.176zm7 0h-2.221zM84.176 121.777H76M79.5 113H62.324zm-23 0h-4.221z"
})));
export default SvgSearch;